import { Component } from "../component"
import { debounce } from "../helpers/debounce"
import { iterable } from "../helpers/iterable"

export class SectionCollectionList extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      firstInLine: "-first-in-line",
    }
  }

  ui() {
    return {
      items: ".section-collection-list-item",
    }
  }

  detectLines() {
    const { items } = this.$ui
    const { firstInLine } = this.dynamicClasses
    let top = -1

    iterable(items).forEach((item) => {
      let isFirstInLine = false

      if (item.offsetTop > top) {
        isFirstInLine = true
        top = item.offsetTop
      }

      item.classList.toggle(firstInLine, isFirstInLine)
    })
  }

  attachEvents() {
    window.addEventListener(
      "resize",
      debounce((e) => {
        this.detectLines()
      })
    )
  }

  created() {
    const timeouts = [1, 2, 5, 10, 20, 30, 40, 80]
    this.detectLines()
    this.attachEvents()

    timeouts.forEach((timeout) => {
      setTimeout(() => {
        this.detectLines()
      }, timeout * 100)
    })
  }
}
